import { render, staticRenderFns } from "./listbox_input.vue?vue&type=template&id=123a2472"
import script from "./listbox_input.vue?vue&type=script&lang=js"
export * from "./listbox_input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports